import { createSlice } from '@reduxjs/toolkit';
import { REDUX_ASYNC_STATUSES } from '../../consts/consts';

const { IDLE, LOADING, SUCCEEDED, FAILED } = REDUX_ASYNC_STATUSES;

const initialState = {
  settlements: [],
  getSettlementsStatus: IDLE,

  createSettlementStatus: IDLE,

  updateSettlementStatus: IDLE,

  cutbackReasons: [],
  getCutbackReasonsStatus: IDLE,

  settlementPdfSummaryStatus: IDLE,

  exportSettlementsStatus: IDLE
};

const settlementsSlice = createSlice({
  name: 'settlements',
  initialState,
  reducers: {
    getSettlements: (state) => {
      state.getSettlementsStatus = LOADING;
    },
    getSettlementsSucceeded: (state, action) => {
      state.settlements = action.payload;
      state.getSettlementsStatus = SUCCEEDED;
    },
    getSettlementsFailed: (state) => {
      state.getSettlementsStatus = FAILED;
    },
    clearSettlements: (state) => {
      state.settlements = [];
      state.getSettlementsStatus = IDLE;
    },

    createSettlement: (state) => {
      state.createSettlementStatus = LOADING;
    },
    createSettlementSucceeded: (state) => {
      state.createSettlementStatus = SUCCEEDED;
    },
    createSettlementFailed: (state) => {
      state.createSettlementStatus = FAILED;
    },

    updateSettlement: (state) => {
      state.updateSettlementStatus = LOADING;
    },
    updateSettlementSucceeded: (state) => {
      state.updateSettlementStatus = SUCCEEDED;
    },
    updateSettlementFailed: (state) => {
      state.updateSettlementStatus = FAILED;
    },

    getSettlementPdfSummary: (state) => {
      state.settlementPdfSummaryStatus = LOADING;
    },
    getSettlementPdfSummarySucceeded: (state) => {
      state.settlementPdfSummaryStatus = SUCCEEDED;
    },
    getSettlementPdfSummaryFailed: (state) => {
      state.settlementPdfSummaryStatus = FAILED;
    },

    exportSettlements: (state) => {
      state.exportSettlementsStatus = LOADING;
    },
    exportSettlementsSucceeded: (state) => {
      state.exportSettlementsStatus = SUCCEEDED;
    },
    exportSettlementsFailed: (state) => {
      state.exportSettlementsStatus = FAILED;
    },

    getCutbackReasons: (state) => {
      state.getCutbackReasonsStatus = LOADING;
    },
    getCutbackReasonsSucceeded: (state, action) => {
      state.cutbackReasons = action.payload;
      state.getCutbackReasonsStatus = SUCCEEDED;
    },
    getCutbackReasonsFailed: (state) => {
      state.getCutbackReasonsStatus = FAILED;
    },

    createCutbackReason: (state) => {
      state.createCutbackReasonStatus = LOADING;
    },
    createCutbackReasonSucceeded: (state) => {
      state.createCutbackReasonStatus = SUCCEEDED;
    },
    createCutbackReasonFailed: (state) => {
      state.createCutbackReasonStatus = FAILED;
    }
  }
});

export const {
  getSettlements,
  getSettlementsSucceeded,
  getSettlementsFailed,
  clearSettlements,
  createSettlement,
  createSettlementSucceeded,
  createSettlementFailed,
  updateSettlement,
  updateSettlementSucceeded,
  updateSettlementFailed,
  getSettlementPdfSummary,
  getSettlementPdfSummarySucceeded,
  getSettlementPdfSummaryFailed,
  exportSettlements,
  exportSettlementsSucceeded,
  exportSettlementsFailed,
  getCutbackReasons,
  getCutbackReasonsSucceeded,
  getCutbackReasonsFailed,
  createCutbackReason,
  createCutbackReasonSucceeded,
  createCutbackReasonFailed
} = settlementsSlice.actions;

export default settlementsSlice.reducer;
